export default __webpack_public_path__ + "static/media/KA_Hex.bad43b11.svg";